module.exports = __webpack_public_path__ + "static/media/YM81_2.58abbe25.jpg";